import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'rt-verified-email',
  imports: [
    ButtonModule,
  ],
  standalone: true,
  templateUrl: './verified-email.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifiedEmailComponent {
  private dialogRef = inject(DynamicDialogRef);

  close(): void {
    this.dialogRef.close({ hasChanges: false });
  }
}
